import { useEffect, useRef, useState } from "react";

export default function ResultsSection() {
  const sectionRef = useRef(null);
  const [startCount, setStartCount] = useState(false);

  const [years, setYears] = useState(0);
  const [money, setMoney] = useState(0);
  const [people, setPeople] = useState(0);

  // Figyeli mikor kerül viewportba
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true);
          observer.disconnect(); // csak egyszer fusson le
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  // Számláló animáció
  useEffect(() => {
    if (!startCount) return;

    const animate = (setter, target, duration = 1200) => {
      const startTime = performance.now();

      const step = (time) => {
        const progress = Math.min((time - startTime) / duration, 1);
        setter(Math.floor(progress * target));
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    };

    animate(setYears, 4);
    animate(setMoney, 3);
    animate(setPeople, 2000);
  }, [startCount]);

  return (
    <section id="eredmenyek" className="section pt-0" ref={sectionRef}>
      <div className="card border-0 bg-transparent p-0">
        <p className="h5 mb-5 text-center opacity-75 text-uppercase tracking-widest">
          Eredményeink
        </p>

        <div className="grid grid-3 text-center" style={{ gap: "32px" }}>
          <div className="p-4 rounded-4 bg-dark-soft border border-white border-opacity-5">
            <h3 className="h2 mb-1" style={{ color: "var(--warning-color)" }}>
              {years}+ év
            </h3>
            <div className="small">Szakmai tapasztalat</div>
          </div>

          <div className="p-4 rounded-4 bg-dark-soft border border-white border-opacity-5">
            <h3 className="h2 mb-1" style={{ color: "var(--warning-color)" }}>
              {money} milliárd
            </h3>
            <div className="small">Elnyert támogatás</div>
          </div>

          <div className="p-4 rounded-4 bg-dark-soft border border-white border-opacity-5">
            <h3 className="h2 mb-1" style={{ color: "var(--warning-color)" }}>
              {people}+ fő
            </h3>
            <div className="small">Sikeres képzés</div>
          </div>
        </div>
      </div>
    </section>
  );
}
